import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AppAccessButton } from '../_templates/AppAccessButton'
import { useWorkspaceService } from '../../_services/WorkspaceService'

interface AppCtaButtonProps {
  app: any
  size: 'medium' | 'small'
  postCtaButtonClick: () => void
  hasSuggestedApps?: boolean
}

const AppCtaButton: React.FC<AppCtaButtonProps> = ({
  app,
  size,
  postCtaButtonClick,
  hasSuggestedApps
}) => {
  const navigate = useNavigate()
  const { updateActiveWorkspace } = useWorkspaceService()

  const routeToWorkspace = (workspaceId?: any) => {
    if (workspaceId) {
      updateActiveWorkspace(workspaceId !== 'my-workspace' ? workspaceId : 'my-workspace')
      navigate(`/workspace?activeApp=${app.uniqueName}`)
    }
    if (postCtaButtonClick) {
      postCtaButtonClick()
    }
  }

  return (
    <>
      {app.arc && Object.keys(app.arc).length && (
        <AppAccessButton
          application={app}
          params={app.arc}
          onOpenApp={(workspaceId: any) => routeToWorkspace(workspaceId)}
          size={size}
          hasSuggestedApps={hasSuggestedApps}
        />
      )}
    </>
  )
}

export default AppCtaButton
